/* eslint-disable */
import { secureGet, securePost, secureGetPdf, securePostPdf } from 'config/apiConfig';

export const getFactures = async ({
  page = 0, size = 10, sort = 'date,desc',
  statuses = [], souche = '',
  startDate = '', endDate = '',
  startEcheance = '', endEcheance = '',
}, search) => {
  const params = new URLSearchParams({ page, size, sort });
  const body = {};
  if (search) body.search = search;
  if (statuses.length) body.statuses = statuses;
  if (souche) body.souche = souche;
  if (startDate) body.startDate = startDate;
  if (endDate) body.endDate = endDate;
  if (startEcheance) body.startEcheance = startEcheance;
  if (endEcheance) body.endEcheance = endEcheance;
  const { data } = await securePost(`/orders/search?${params.toString()}`, body);
  return data;
};

export const downloadFacturePdf = async (reference) => {
  const { data } = await secureGetPdf(`/orders/getFacture/${reference}`, {
    headers: { Accept: 'application/pdf, application/json' },
  });
  return data;
};

export const exporterFactures = async ({ startDate, endDate, souche, type = 'all', officiel = false }) => {
  const response = await securePostPdf('/orders/releve', { startDate, endDate, souche, type, officiel }, {
    headers: { 'content-type': 'application/json', Accept: 'application/pdf, application/json' },
  });
  return response;
};

export const getFactureTotals = async () => {
  const { data } = await secureGet('/orders/totals');
  return data;
};

export const getFactureDetails = async (orderId) => {
  const { data } = await secureGet(`/orders/${orderId}/details`);
  return data;
};

export const getFactureById = async (orderId) => {
  const { data } = await secureGet(`/orders/${orderId}`);
  return data;
};
